import * as React from 'react'

export const SvgVideoTranscript = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    {...props}
    viewBox="0 0 32 22"
    style={{
      isolation: 'isolate',
      fill: 'none',
      color: 'white',
    }}
  >
    <rect
      x="1"
      y="1"
      width="30"
      height="20"
      rx="3"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M10.9141 12.5V7.02884H14.5V4.5H4.5V7.02884H8.14474V12.5H10.9141Z"
      fill="white"
    />
    <rect
      x="4.5"
      y="15.1001"
      width="23"
      height="2.39999"
      rx="1.2"
      fill="white"
    />
    <rect x="17.5" y="4.5" width="10" height="2.39999" rx="1.2" fill="white" />
    <rect x="17.5" y="10" width="10" height="2.39999" rx="1.2" fill="white" />
  </svg>
)
export default SvgVideoTranscript
